// extracted by mini-css-extract-plugin
module.exports = {"store_pending_container":"styles_store_pending_container__zwoH2"};